import { User } from "./User";

export class UserGroup {
	public static readonly $type: string = "UserGroup";
	public readonly $type: string = UserGroup.$type;

	public id?: number;
	public name: string = "";
	public users: Set<User> = new Set<User>();
}
